// extracted by mini-css-extract-plugin
module.exports = {"GrowingEco":"growingEco_GrowingEco__y1RUy"};